import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestResellersTabsCounters } from "./resellersTabsCounters.request";
import { ResellersTabsCountersResponse } from "./resellersTabsCounters.types";

const useResellersTabsCounters = (
  options?: QueryOptions<
    ResellersTabsCountersResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["reseller", "counters"],
    queryFn: requestResellersTabsCounters,
    ...options
  });

  return {
    countersByLevel: data?.countsByLevel,
    allCountersTotal: data?.countsByLevel?.reduce(
      (acc, curr) => acc + curr.count,
      0
    ),
    ...rest
  };
};

export default useResellersTabsCounters;
